import React from 'react';

import { Trigger } from '../components';

export const ModalAlertTrigger = () => (
  <Trigger shouldNotRenderAt="mobile" modal />
);
